import React from 'react'
import { BillingFrequency, ContractType } from '../../types/agreement'
import { getValidBillingFrequencies } from '../../utils/consistencyRules'

const labels: Record<BillingFrequency, string> = {
  one_time: 'One-time',
  weekly: 'Weekly',
  bi_weekly: 'Bi-weekly',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  annually: 'Annually',
  after_each_service: 'After each service',
  progress: 'Progress (milestone billing)',
}

interface Props {
  value: string
  contractType: ContractType
  onChange: (value: BillingFrequency) => void
  className?: string
  disabled?: boolean
  id?: string
}

export default function BillingFrequencySelect({
  value,
  contractType,
  onChange,
  className,
  disabled,
  id,
}: Props) {
  const valid = getValidBillingFrequencies(contractType)
  return (
    <select
      id={id}
      value={value || ''}
      onChange={(e) => onChange(e.target.value as BillingFrequency)}
      disabled={disabled}
      className={
        className ||
        'rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:ring-blue-500'
      }
    >
      <option value="">Select frequency...</option>
      {valid.map((opt) => (
        <option key={opt} value={opt}>
          {labels[opt]}
        </option>
      ))}
    </select>
  )
}
